export default "__VITE_ASSET__CmmPWXU7__"